import React from 'react';
import PropTypes from 'prop-types';

import * as Styles from './index.styles';

const { StyledStandardTag, StyledIcon } = Styles;

export const StandardTag = ({ children, ...otherProps }) => (
    <StyledStandardTag {...otherProps}>
        <StyledIcon icon={['fas', 'tag']} />
        {children}
    </StyledStandardTag>
);

StandardTag.propTypes = {
    light: PropTypes.bool,
    children: PropTypes.node.isRequired,
};

StandardTag.defaultProps = {
    light: false,
};

StandardTag.Styles = Styles;
